import { render } from "./Ball1.vue?vue&type=template&id=97ad92da&bindings={\"eye\":\"setup\"}"
import script from "./Ball1.vue?vue&type=script&lang=js"
export * from "./Ball1.vue?vue&type=script&lang=js"
script.render = render

export default script